import { NotifyHelper } from "../../../helpers/toast";
import { eTongHopHocPhiActionsObj } from "../../action-types/tong-hop/ITongHopHocPhiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tongHopHocPhiActions = {
  ...generateActions(eTongHopHocPhiActionsObj, "TONG_HOP_HOC_PHI"),
  ...generateActionForKey(
    eTongHopHocPhiActionsObj,
    "TONG_HOP_HOC_PHI",
    "EXPORT_EXCEL_SUCCESS",
    (m) => {
      NotifyHelper.Success(m);
    }
  ),
  ...generateActionForKey(
    eTongHopHocPhiActionsObj,
    "TONG_HOP_HOC_PHI",
    "EXPORT_EXCEL_ERROR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
